import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
  { key: "/special-deliveries", label: "Intake" },
  { key: "/special-deliveries/plan", label: "Planning Board" },
];

const SpecialDeliveryNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey =
    TABS.find((tab) => tab.key === location.pathname)?.key ||
    "/special-deliveries";

  const onChange = (key) => {
    if (key !== location.pathname) {
      navigate(`${key}${location.search}`);
    }
  };

  return (
    <Tabs
      activeKey={activeKey}
      onChange={onChange}
      items={TABS.map((tab) => ({ key: tab.key, label: tab.label }))}
    />
  );
};

export default SpecialDeliveryNav;
